<n-slide-window *ngIf="pageReady"
    [loading]="loading"
    [visible]="windowVisible"
    [width]="isSimpleMode ? '6.08rem' : '7rem'"
    (onHide)="close()">
    <n-header>
        <h1>{{i18n.configureTitle}}</h1>
        <n-help-link key="servicenisView"></n-help-link>
    </n-header>

    <n-retry *ngIf="loadFailed" (onRetry)="refresh()"></n-retry>

    <form *ngIf="!loadFailed && vm"
        [simpleMode]="isSimpleMode"
        [errorMessage]="errorMessage"
        [formGroup]="vm"
        [ngClass]="{ 'form-width-simple': isSimpleMode, 'common-form': !isSimpleMode }">
        <!-- 所属租户 -->
        <n-form-item [label]="i18n.vstoreLab" *ngIf="!isSimpleMode">
            <div class="n-form-item-text">{{data.vstoreName || UNPLACEHOLDER}}</div>
        </n-form-item>
        <!-- 域名 -->
        <n-form-item [label]="i18n.domainLab"
            [required]="true">
            <input type="text"
                id="service-nis-configure-domain"
                nInput
                formControlName="NISDOMAIN">
        </n-form-item>
        <!-- 主服务器地址 -->
        <n-form-item [label]="i18n.primaryIpAddressLab"
            [required]="true">
            <div class="interval-10">
                <input type="text"
                    id="service-nis-configure-primaryIp"
                    nInput
                    [placeholder]="i18n.ipTip"
                    formControlName="primaryIp">
                <button id="service-nis-configure-primaryIp-test"
                    nButton
                    [label]="i18n.testBtn"
                    [disabled]="!vm.get('primaryIp')['_pendingValue']"
                    (click)="test('primaryIp')">
                </button>
            </div>
        </n-form-item>
        <!-- 备服务器地址1 -->
        <n-form-item [label]="i18n.standbyIpAddressLab1" [showAvailableLabel]="simpleModeStyle">
            <div class="interval-10">
                <input type="text"
                    id="service-nis-configure-standbyIp1"
                    nInput
                    [placeholder]="i18n.ipTip"
                    formControlName="standbyIp1">
                <button id="service-nis-configure-standbyIp1-test"
                    nButton
                    [label]="i18n.testBtn"
                    [disabled]="!vm.get('standbyIp1')['_pendingValue']"
                    (click)="test('standbyIp1')">
                </button>
            </div>
        </n-form-item>
        <!-- 备服务器地址2 -->
        <n-form-item [label]="i18n.standbyIpAddressLab2" [showAvailableLabel]="simpleModeStyle">
            <div class="interval-10">
                <input type="text"
                    id="service-nis-configure-standbyIp2"
                    nInput
                    [placeholder]="i18n.ipTip"
                    formControlName="standbyIp2">
                <button id="service-nis-configure-standbyIp2-test"
                    nButton
                    [label]="i18n.testBtn"
                    [disabled]="!vm.get('standbyIp2')['_pendingValue']"
                    (click)="test('standbyIp2')">
                </button>
            </div>
        </n-form-item>
    </form>

    <n-footer>
        <button id="service-nis-configure-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="service-nis-configure-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
